import { createLoadingReducer } from './utils';

export default createLoadingReducer('TELKEY_SETTINGS');
